<template>
  <div>
    <router-view v-if="$route.meta.title" :key="routeKey" />
    <div v-else class="min-h-screen w-full flex flex-col items-center justify-center">
      <loading variant="dark" overlay transparent />
    </div>
  </div>
</template>

<script>
import { setAppLang, defaultLang, getAppLang } from '@/utils/cookie-helper';
import loading from '@/components/new/common/loading';

export default {
  name: 'App',
  components: {
    loading,
  },
  computed: {
    routeKey() {
      return this.$route.fullPath;
    },
  },
  created() {
    this.initApp();
  },
  methods: {
    initApp() {
      const langDefault = getAppLang() || defaultLang();
      this.$i18n.locale = langDefault;
      document.querySelector('html').setAttribute('lang', langDefault);
      setAppLang(langDefault);
    },
  },
};
</script>
